import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import interceptor from "./backend/refresh-token";
import { RecoilRoot } from 'recoil';
import RecoilNexus from "recoil-nexus";
import PaymentPlanRequiredModal from "./components/modals/PaymentPlanRequiredModal";
interceptor.registerRequestInterceptor();

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <RecoilNexus /> {/** Used for getting/setting Recoil state anywhere */}
      <PaymentPlanRequiredModal />
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
